import { IUserNotification } from '../../models/IUserNotification';
import { NotificationDefaultProvider } from '../NotificationDefaultProvider';
import { Messages } from '../../../codegen/Localize';
import { escapeMarkdown } from '../../../settings/welcomeChannelCustomization/utils/MarkdownHtml';

export class CommentingContentProvider extends NotificationDefaultProvider {

    public getNotificationTitle(notification: IUserNotification): string {
        const userName = escapeMarkdown(notification.senderDisplayName);
        const viewName = escapeMarkdown(notification.content.viewName);
        const workbookName = escapeMarkdown(notification.content.workbookName);

        return Messages.userNotification_commenting_title({USER_NAME: userName, VIEW_NAME: viewName, WORKBOOK_NAME: workbookName});
    }

    public getNotificationContent(notification: IUserNotification): string {
        return escapeMarkdown(notification.content.commentText);
    }
}
